import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { DownloadOutlined } from '@ant-design/icons'
import { LOGIN_PATH } from 'account/login/Login'
import { Layout as AntLayout, Col, Menu, Row } from 'antd'
import Logo from 'ichraDecisionTool/common/Logo'

import getProspectAnalysisLink from 'core/application/ichraDecisionTool/dashboard/getProspectAnalysisLink'
import getProspectPermissions, { ProspectPermissions } from 'core/application/ichraDecisionTool/getProspectPermissions'

import Button from 'common/components/general/Button'

import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import { queryRequest } from 'common/RequestUtils'

import IchraDecisionToolAnalysisComplete from 'assets/images/IchraDecisionToolAnalysisComplete'

const ProspectAnalysis = () => {
  const { t: translate } = useTranslation('ichra-decision-tool')

  let code = useUrlQueryParam('code')
  const [downloadingTemplate] = useState<boolean>(false)
  const [analysisDownloadLink, setAnalysisDownloadLink] = useState<string>('')

  const history = useHistory()
  useEffect(() => {
    userIsAllowedToEnterProspectSignUpFlow()
      .then((res) => fetchAnalysisDownloadLink())
      .catch((err) => history.push(LOGIN_PATH))
  }, [])

  const userIsAllowedToEnterProspectSignUpFlow = async (): Promise<boolean> => {
    if (!code) return Promise.reject(false)
    const res: ProspectPermissions[] = await queryRequest(() => getProspectPermissions())
    return res.includes(ProspectPermissions.AccessPbaAnalysis) ? Promise.resolve(true) : Promise.reject(false)
  }

  const fetchAnalysisDownloadLink = async () => {
    const res = await queryRequest(() => getProspectAnalysisLink(code ?? ''))
    setAnalysisDownloadLink(res)
  }

  const downloadTemplate = async () => {
    window.open(analysisDownloadLink, '_blank')
  }

  return (
    <AntLayout>
      <Menu mode="horizontal">
        <Menu.Item>
          <Logo />
        </Menu.Item>
      </Menu>
      <AntLayout className="dashboard_body">
        <AntLayout className="dashboard-layout-content">
          <div className="flex flex__center">
            <IchraDecisionToolAnalysisComplete />
          </div>

          <div className="flex flex__center mt-24">
            <div className="width_40">
              <div>
                <div className="flex flex__center">
                  <h2>{translate('analysis.title')}</h2>
                </div>
                <p className="color-gray-8">{translate('analysis.content')}</p>
                <div className="flex flex__center mt-24">
                  <Button
                    customIcon={<DownloadOutlined />}
                    className="mt-8"
                    type="primary"
                    onClick={downloadTemplate}
                    loading={downloadingTemplate}
                  >
                    {translate('analysis.download-report').toUpperCase()}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </AntLayout>
      </AntLayout>
    </AntLayout>
  )
}

export default ProspectAnalysis
